import React, { FC } from 'react';
import styles from '../SelectTemplateStep.scss';
import { useAppStore } from 'stores/state';
import { templates, templatesByCategory } from 'config/templates';
import { MediaCard } from 'components/MediaCard/MediaCard';
import { templateUtils } from 'utils/templates';

export const SelectTemplateStepOptions: FC = () => {
  const category = useAppStore((state) => state.category);
  const templateIds = category ? templatesByCategory[category] : [];
  const templateSlug = useAppStore((state) => state.templateSlug);
  const setTemplateSlug = useAppStore((state) => state.setTemplateSlug);

  return (
    <div className={styles.selectTemplateStepOptions}>
      {templateIds.map((templateKey) => {
        const template = templates[templateKey];
        const imageSrc = templateUtils.getAssetUrl(template.assets.desktop);
        return (
          <MediaCard
            onClick={() => setTemplateSlug(templateKey)}
            isSelected={templateSlug === templateKey}
            imageSrc={imageSrc}
            key={templateKey}
          />
        );
      })}
    </div>
  );
};
